import React from 'react'
import type { ValidatedRecord } from '../../model/types'
import styles from './ImportDiffPreview.module.css'

interface Props {
  record: ValidatedRecord | null
}

/** Detail panel showing per-field before → after for the selected row. */
export const ImportDiffPreview: React.FC<Props> = ({ record }) => {
  if (!record) {
    return <div className={styles.empty}>위 표에서 행을 선택하면 변경 내용이 표시됩니다.</div>
  }

  if (record.status === 'error') {
    return (
      <div className={styles.errorList}>
        <div className={styles.title}>오류 상세</div>
        {record.issues.map((issue, idx) => (
          <div key={idx} className={styles.errorItem}>
            <span className={styles.errorCode}>{issue.code}</span>
            <span className={styles.errorMessage}>{issue.message}</span>
          </div>
        ))}
      </div>
    )
  }

  if (record.status === 'unmatched') {
    return (
      <div className={styles.unmatched}>
        <div className={styles.title}>미매칭 상세</div>
        <p className={styles.unmatchedMsg}>
          id <code>{record.record.id}</code>는 현재 맵에 존재하지 않아 적용에서 제외됩니다.
        </p>
      </div>
    )
  }

  // valid
  if (!record.diff || record.diff.changedKeys.length === 0) {
    return <div className={styles.empty}>변경 내용 없음 (모든 셀이 현재 값과 동일).</div>
  }

  return (
    <div className={styles.diff}>
      <div className={styles.title}>
        변경 미리보기 ({record.diff.changedKeys.length}개 필드)
      </div>
      <table className={styles.diffTable}>
        <thead>
          <tr>
            <th>필드</th>
            <th>현재 (before)</th>
            <th>새 값 (after)</th>
          </tr>
        </thead>
        <tbody>
          {record.diff.changedKeys.map(key => (
            <tr key={key}>
              <td className={styles.keyCell}>{key}</td>
              <td className={styles.beforeCell}>{formatValue(record.diff!.before[key])}</td>
              <td className={styles.afterCell}>{formatValue(record.diff!.after[key])}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

function formatValue(v: unknown): string {
  if (v === undefined || v === null) return '(없음)'
  if (typeof v === 'string' && v === '') return '(빈 문자열)'
  if (Array.isArray(v)) return `[${v.length}개]: ${v.slice(0, 3).join(', ')}${v.length > 3 ? '...' : ''}`
  if (typeof v === 'object') return JSON.stringify(v)
  return String(v)
}
